import React from 'react'
import * as R from 'ramda'
import { Body } from '@cjdev-internal/visual-stack-x/Panel'
import { AlternatePayee, SummaryPageProps } from '../../../types'
import PayeeInfo from '../PayeeInfo'
import { ListView } from '@cjdev-internal/visual-stack-x/ListView'
import { Box } from '@cjdev-internal/visual-stack-x/components/Box'

const SummaryPage = ({ handleView, data, isFetching, intl, PayeeItemComponent = PayeeInfo }: SummaryPageProps) => {

  const handleViewDetails = (id: number) => {
    const selectedPayee = data.filter(alternatePayee => alternatePayee.id === id).at(0);
    handleView(selectedPayee!)
  }

  return (
    <Body style={{ position: 'relative' }}>
      <ListView<AlternatePayee>
        data={data}
        indexer={(ap: AlternatePayee) => ap.id}
        separator={false}
        isLoading={isFetching}
        renderEmptyState={() => <></>}
        renderContent={(ap: AlternatePayee) => (
          <PayeeItemComponent
            name={ap.name}
            lastModified={ap.lastModified}
            buttonLabel={intl.summaryPage.viewButton}
            onClick={() => handleViewDetails(ap.id)}
          />
        )}
      />
    </Body>
  )
}

export default SummaryPage